import * as React from "react";
import { isMarketType, getDictPhrase, prepareSelections } from "../../../../../../helpers";
import { BetBtnAmerican } from "../../../../components";
export var renderBetButtonsAmerican = function (cardProps, market, componentPrefix) {
    var selections = prepareSelections(market, cardProps.event.isTeamSwap);
    return (React.createElement("div", { key: componentPrefix + "__" + market.id, className: "rj-ev-list__" + componentPrefix + "__section rj-ev-list__" + componentPrefix + "__section--" + market.template, "data-uat": "div-ev-list-" + componentPrefix + "-section" }, selections && selections.map(function (s, index) {
        var betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
        var name = getSelectionName(cardProps.dict, market, s, cardProps.isDesktop, cardProps.showMLTeamName);
        return (React.createElement(BetBtnAmerican, { key: componentPrefix + "__bet-btn__" + (market.id || "m") + "-" + (s && s.id || "s") + "-" + index, isDisabled: s.isDisabled, classNames: "" + betslipModifier, handler: function () { return cardProps.handlers.betButton(market, s); }, text: name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds, hideLowOdds: cardProps.hideLowOdds }));
    })));
};
var getSelectionName = function (dict, market, selection, isDesktop, showMLTeamName) {
    if (!selection.outcomeType) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML") && !isDesktop) {
        return getNameML(selection, showMLTeamName, dict);
    }
    if (isMarketType(market.marketType.id, "OU")) {
        return getDictPhrase(dict, "AmericanBtn" + selection.outcomeType);
    }
    return "";
};
var getNameML = function (selection, showMLTeamName, dict) {
    return showMLTeamName && selection.name
        || getDictPhrase(dict, "AmericanBtnML" + selection.outcomeType);
};
//# sourceMappingURL=renderBetButtonsAmerican.js.map